import { Phone, Mail } from "lucide-react";
import { LineReveal, Reveal } from "../components/Reveal";
import { ContactForm } from "../components/ContactForm";
import { MapCard } from "../components/MapCard";
import { HoursTable } from "../components/HoursTable";
import { BUSINESS } from "../lib/site";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="pt-28 pb-16">
      <header className="max-w-7xl mx-auto px-6 md:px-12 pt-6 pb-12">
        <p className="kicker text-crust mb-4">Nous contacter</p>
        <LineReveal
          as="h1"
          className="font-serif font-light text-charcoal text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight"
          lines={["Écrivez-nous,", "passez nous voir."]}
          delay={0.15}
        />
        <Reveal delay={0.6}>
          <p className="mt-6 max-w-xl text-base sm:text-lg text-ash leading-relaxed">
            Une question, une réclamation, une demande de commande&nbsp;? Laissez-nous
            un message, ou appelez-nous directement — nous répondons avec plaisir.
          </p>
        </Reveal>
      </header>

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
        {/* Formulaire */}
        <div>
          <h2 className="font-serif text-3xl sm:text-4xl text-charcoal mb-8">Nous laisser un message</h2>
          <ContactForm />
        </div>

        {/* Informations pratiques */}
        <aside data-testid="contact-info" className="flex flex-col gap-8">
          <div>
            <p className="kicker text-crust mb-4">Par téléphone</p>
            <a
              href={BUSINESS.phoneLink}
              data-testid="contact-phone"
              className="inline-flex items-center gap-3 font-serif text-4xl sm:text-5xl text-charcoal hover:text-crust transition-colors duration-300"
            >
              <Phone size={28} className="text-crust" />
              {BUSINESS.phoneDisplay}
            </a>
          </div>

          <div>
            <p className="kicker text-crust mb-4">Par e-mail</p>
            <a
              href={BUSINESS.emailLink}
              data-testid="contact-email-link"
              className="inline-flex items-center gap-3 font-serif text-2xl sm:text-3xl text-charcoal hover:text-crust transition-colors duration-300 break-all"
            >
              <Mail size={24} className="text-crust shrink-0" />
              {BUSINESS.emailDisplay}
            </a>
          </div>

          <div>
            <p className="kicker text-crust mb-4">Nous trouver</p>
            <MapCard testId="contact-map" height="h-64" />
          </div>

          <div>
            <p className="kicker text-crust mb-4">Horaires d'ouverture</p>
            <HoursTable tone="light" testId="contact-hours" />
          </div>
        </aside>
      </div>
    </div>
  );
}
